import client from '/src/services/client.js';

export default {
    //getPrompts: (data) => client.get('api/conversations', data),
    getPrompts: (data) => client.get(`ia/prompts`, data),
    updatePrompt: (id, data) => client.put(`ia/prompts/${id}`, data),
};
